import styled, { css } from 'styled-components';
const TableCSS = css `
  width: 100%;
  border-spacing: 0;
`;
export const StyledTable = styled.table `
  ${TableCSS}
`;
export const BlockLayout = styled.div `
  ${TableCSS}

  &.sticky {
    .header,
    .footer {
      position: sticky;
    }

    .body [role='row'] {
      align-items: center;
    }
  }
`;
